import { render, staticRenderFns } from "./AssignPermissionResource.vue?vue&type=template&id=5e389eb4&"
import script from "./AssignPermissionResource.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionResource.vue?vue&type=script&lang=js&"
import style0 from "./AssignPermissionResource.vue?vue&type=style&index=0&id=5e389eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports